// File: config.base.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items used throughout the application.
// Other Contributors:

const CGP_LOGIN_DEV = `https://cgp-game-authn-dev.ocp-epgiw1.epg.nam.gm.com/authn/?RelayState=`
const CGP_LOGIN_QA = `https://cgp-game-authn-qa.ocp-epgiw1.epg.nam.gm.com/authn/?RelayState=`
const CGP_LOGIN_TEST = `https://cgp-game-authn-test.ocp-epgiw1.epg.nam.gm.com/authn/?RelayState=`;
export const cgpLoginUrls = {
    LOCAL: CGP_LOGIN_DEV,
    DEV: CGP_LOGIN_DEV,
    QA: CGP_LOGIN_QA,
    TEST: CGP_LOGIN_TEST,
    PERF: "https://cgp-game-authn-perf.apps.pcfepgwi.gm.com/authn/?RelayState=",
    PROD: "https://mfg-gateway.gm.com/authn/authn/?RelayState="
};

const CGP_SECURITY_DEV = `https://cgp-game-authn-dev.ocp-epgiw1.epg.nam.gm.com/authn/token/`;
const CGP_SECURITY_QA = `https://cgp-game-authn-qa.ocp-epgiw1.epg.nam.gm.com/authn/token/`;
const CGP_SECURITY_TEST = `https://cgp-game-authn-test.ocp-epgiw1.epg.nam.gm.com/authn/token/`;
export const cgpSecurityUrls = {
    LOCAL: CGP_SECURITY_DEV,
    DEV: CGP_SECURITY_DEV,
    QA: CGP_SECURITY_QA,
    TEST: CGP_SECURITY_TEST,
    PERF: "https://cgp-game-authn-perf.apps.pcfepgwi.gm.com/authn/token/",
    PROD: "https://mfg-gateway.gm.com/authn/authn/token/"
};

export const baseConfig = {
    appInfo: {
        name: 'Virtual Engineering',
        version: '0.0.2',
        company: 'GENERAL MOTORS'
    },
    baseUrl: '',
    authentication : {
        authenticationCookie: 'Authorization',
        authenticationType: 'Bearer',
        userInfoCookie: 'UserInfo'
    }
};
